export default __webpack_public_path__ + "static/media/200_ml_e.8e9e8846.svg";